import React from "react"

// Libraries
import { StaticImage } from "gatsby-plugin-image"

// Components
import LottieObserved from "components/lottie-observed/"

// Animations
import ArenaAnimation from "assets/animations/case-studies/arena/cover.json"
import IndiciusAnimation from "assets/animations/case-studies/indicius/cover.json"
import NubiAnimation from "assets/animations/case-studies/nubi/cover.json"
import OSDEAnimation from "assets/animations/case-studies/osde/cover.json"
import LymeMINDAnimation from "assets/animations/case-studies/lymemind/cover.json"
import KapitalAnimation from "assets/animations/case-studies/kapital/cover.json"
import SamsungAnimation from "assets/animations/case-studies/samsung/cover.json"
// import Salsa from "assets/animations/case-studies/salsa/salsa-cs.json"

const caseStudies = [
  {
    title:
      "Imagining a sophisticated, tech-focused brand for the cloud-based solution to multiplayer games",
    client: "Hathora",
    slug: "hathora",
    new: false,
    year: "2022-2023",
    categories: ["Website Development"],
    covers: {
      default: (
        <StaticImage
          src="../assets/animations/case-studies/hathora/hathora-banner.png"
          alt=""
          quality={100}
        />
      ),
    },
  },
  {
    title: "How a long-term partnership keeps elevating an AI hiring tool",
    client: "Arena Analytics",
    slug: "arena-analytics",
    new: false,
    year: "2021-2022",
    categories: [
      "Brand Narrative Workshop",
      "Visual Branding",
      "UX/UI Design",
      "Website Development",
    ],
    covers: {
      default: <LottieObserved animation={ArenaAnimation} loop />,
    },
  },
  {
    title:
      "Building a bold new look for a trailblazing FinTech platform with multiple audiences",
    client: "Stonehaven",
    slug: "stonehaven",
    new: false,
    year: "2022",
    categories: [
      "UX/UI Design",
      "Brand Narrative Workshop",
      "Visual Branding",
      "Website Development",
    ],
    covers: {
      default: (
        <StaticImage
          src="../assets/images/case-studies/stonehaven/cover--default.png"
          width={464}
          height={364}
          quality={100}
        />
      ),
      large: (
        <StaticImage
          src="../assets/images/case-studies/stonehaven/cover--large.png"
          width={560}
          height={440}
          quality={100}
        />
      ),
    },
  },
  {
    title: "The new Indicius. A collaborative journey into ourselves",
    client: "Indicius",
    slug: "indicius",
    new: false,
    year: "2021",
    categories: ["Visual Branding", "UX/UI Design", "Website Development"],
    covers: {
      default: <LottieObserved animation={IndiciusAnimation} loop />,
    },
  },
  {
    title: "Bringing Paraguay’s first 100% digital bank to life",
    client: "Kapital",
    slug: "kapital",
    year: "2021",
    new: false,
    categories: [
      "Brand Narrative Workshop",
      "Visual Branding",
      "Design Sprint",
    ],
    covers: {
      default: <LottieObserved animation={KapitalAnimation} loop />,
    },
  },
  {
    title:
      "Aligning two thought-leaders in the field to advance digital health",
    slug: "hpims",
    client: "HPI·MS",
    year: "2020",
    new: false,
    categories: ["Design Sprint", "UX/UI Design", "Website Development"],
    covers: {
      default: (
        <StaticImage
          src="../assets/images/case-studies/hpims/cover--default.png"
          width={464}
          height={364}
          alt=""
          quality={100}
        />
      ),
    },
  },
  {
    title: "How we consolidated LymeMIND's brand and created a dynamic site",
    client: "LymeMIND",
    year: "2020",
    slug: "lymemind",
    categories: ["Visual Branding", "UX/UI Design", "Website Development"],
    covers: {
      default: <LottieObserved animation={LymeMINDAnimation} loop />,
    },
  },
  {
    title:
      "Redesigning Columbia University's genomics app for on-the-go analysis",
    client: "Columbia University",
    year: "2019",
    slug: "acgen",
    categories: ["Visual Branding", "UX/UI Design", "Website Development"],
    covers: {
      default: (
        <StaticImage
          src="../assets/images/case-studies/acgen/cover--default.png"
          width={464}
          height={364}
          alt=""
          quality={100}
        />
      ),
    },
  },
  {
    client: "Nubi",
    year: "2019",
    title:
      "Designing a new product experience for a PayPal partner in the fintech industry",
    slug: "nubi",
    categories: ["UX/UI Design", "Website Development"],
    covers: {
      default: <LottieObserved animation={NubiAnimation} loop />,
    },
  },
  {
    client: "OSDE",
    year: "2019",
    title: "Validating telemedicine with a top health insurance provider",
    slug: "osde",
    categories: ["Design Sprint"],
    covers: {
      default: <LottieObserved animation={OSDEAnimation} loop />,
    },
  },
  {
    client: "Samsung",
    year: "2018",
    title:
      "Crafting a multi-stage website for Samsung’s most innovative meetup",
    slug: "samsung",
    categories: ["UX/UI Design", "Website Development"],
    covers: {
      default: <LottieObserved animation={SamsungAnimation} loop />,
    },
  },
]

export default caseStudies
